import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack } from '@mui/material';
import { PurchaseOrderDetailsContext, PurchaseOrderDetailsValues } from '../../contexts/PurchaseOrderDetailsContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

export const PurchaseOrderDetailsCreditRequestModal = () => {
  const { t } = useTranslation('purchaseOrderDetails');

  const { isCreditRequestModalOpen, createCreditRequestFromModal, closeCreditRequestModal } = useContext(PurchaseOrderDetailsContext) as PurchaseOrderDetailsValues;


  return (
    <Dialog onClose={closeCreditRequestModal}
      open={isCreditRequestModalOpen}>
      <DialogTitle>
        {t('requestCreditModal.title')}
        <CloseDialogAction onCancel={closeCreditRequestModal} />
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t('requestCreditModal.body')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='6px'
          width='100%'>
          <Button variant='primary'
            fullWidth
            size="lg"
            onClick={createCreditRequestFromModal}>
            {t('requestCreditModal.yes')}
          </Button>
          <Button variant='secondary'
            fullWidth
            size="lg"
            onClick={closeCreditRequestModal}>
            {t('requestCreditModal.no')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};